import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getTaxRateSettings, type TaxRateSettings, updateTaxRateSettings } from 'venn-api';

const TAX_GET_SETTINGS_KEY = ['tax-rate-settings'];

export const useWorkspaceTaxSettings = () => {
  const { isFetching, data } = useQuery(
    TAX_GET_SETTINGS_KEY,
    async () => {
      const { content } = await getTaxRateSettings();
      return content;
    },
    {
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true,
    },
  );

  return {
    isLoading: isFetching,
    results: data,
  };
};

export const useUpdateTaxSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (taxRateSettings: TaxRateSettings) => {
      const { content } = await updateTaxRateSettings(taxRateSettings);
      return content;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: TAX_GET_SETTINGS_KEY });
      },
    },
  );
};
